import React from 'react';

import { ILocationsFilter } from '../../../types/ILocationsFilter';

import { DropDownList } from '@progress/kendo-react-dropdowns';

import './locationsFilters.scss';

const LocationsFilters: React.FC<ILocationsFilter> = ({ addresses, onChange, address }) => {
  return <div className='location-filter-wrapper'>
    <DropDownList data={addresses} onChange={onChange} textField='label' dataItemKey={'id'} value={address} />
  </div>;
};

export default LocationsFilters;
